import React, { Component } from 'react'
import { Axios, AxiosResponse } from "axios";
import trans from "trans"
import { connect } from "react-redux";
import { ReduxList } from "app/types/app-types";
import store from "../store";
import _find from "lodash/find";

import {
    css,
    Message,
    Icon,
    Theme,
    Section,
    Button,
} from "@bdfx/mergado-ui-kit"

import { RENDERED_TYPE_AUTOWMREMOVE, WatermarkGroupType } from "../products/types";

import { getWatermarkGroups, projectId, publishWatermarkGroup, publishTemplateToWatermarkDetector } from 'app/helpers/api';

import WatermarkGroupsSelect from "./watermark-groups-select";

import { createToast } from "../actions";
import { textToast } from "app/helpers/toast_factory";
import { getLocale } from "app/helpers/session";
import { setWatermarkGroupsToStore } from "./reducers";
import WatermarkGroupsResults from "./watermark-groups-results";
import WatermarksInEditor from 'template-edit/containers/watermarks-in-editor';
import { Template } from 'app/types/model-types';

interface Props {
    watermarkGroups: ReduxList<WatermarkGroupType[]>
    templates: ReduxList<Template[]>
    setWatermarkGroupsToStore: typeof setWatermarkGroupsToStore
}

interface State {
    selectedGroup: WatermarkGroupType
    showAsModal: boolean
}

class WatermarkGroupsViewTable extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            selectedGroup: null,
            showAsModal: false,
        }
    }

    componentDidMount() {
        if (!this.props.watermarkGroups.isLoaded) {
            this.updateWatermarkGroups()
        }
    }

    updateWatermarkGroups = () => {
        const { selectedGroup } = this.state
        getWatermarkGroups()
            .then((response: AxiosResponse<WatermarkGroupType[]>) => {
                const newWatermarkGroups = response.data

                const newSelectedGroup = (selectedGroup && selectedGroup.id) ? _find(newWatermarkGroups, (watermarkGroup: WatermarkGroupType) => {
                    return watermarkGroup.id === selectedGroup.id
                }) : selectedGroup

                this.props.setWatermarkGroupsToStore(newWatermarkGroups)

                this.setState({
                    selectedGroup: newSelectedGroup,
                })
            })
            .catch(e => {
                console.error('cannot get watermark groups', e)
            })
    }

    setSelectedGroup = (selectedGroupId: number) => {
        const { watermarkGroups } = this.props

        const selectedGroup = _find(watermarkGroups.data, (watermarkGroup: WatermarkGroupType) => {
            return `${watermarkGroup.id}` === `${selectedGroupId}`
        })

        const newGroup: WatermarkGroupType = {
            id: null,
            name: null,
            group_hash: null,
            project_id: projectId,
            published_hash: null,
            published_at: null,
            created_at: null,
            updated_at: null,
        }

        const newSelectedGroup = selectedGroup ? selectedGroup : newGroup

        this.setState({
            selectedGroup: newSelectedGroup,
        })
    }

    /* TODO: BUTTON PUBLISH */
    handlePublishSelected = (force: boolean) => {
        const { selectedGroup } = this.state
        publishWatermarkGroup(selectedGroup.id, force)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(textToast('success', trans('sent'))))
                this.updateWatermarkGroups()
            })
            .catch(e => console.error('error: cannot publish watermark group', e))
    }

    handlePublishTemplate = (watermarkGroupId: number, templateId: number) => {
        publishTemplateToWatermarkDetector(watermarkGroupId, templateId)
            .then((response: AxiosResponse<any>) => {
                console.log('response ok')
            })
            .catch(e => console.error('cannot publish template for watermark detection'))
    }

    render() {
        const { selectedGroup, showAsModal } = this.state
        const { watermarkGroups, templates } = this.props

        const locale = getLocale().replace('_', '-')
        const publishedAt = selectedGroup?.published_at ? new Date(selectedGroup?.published_at) : null
        const header = <span>{selectedGroup?.name} {publishedAt && <span>&nbsp; ({trans('sent')}: {publishedAt.toLocaleDateString(locale)} {publishedAt.toLocaleTimeString(locale)})</span>}</span>
        const imagesWithMasksInSelectedGroup = selectedGroup && selectedGroup.images ? selectedGroup.images.filter(i => i.user_set_objects).length : 0
        const noWatermarks = watermarkGroups.isLoaded && watermarkGroups.data.length === 0
        const isNoWatermarksWarning = noWatermarks && !selectedGroup?.name
        const isEmptyGroup = selectedGroup && (!selectedGroup?.images || selectedGroup?.images?.length === 0)
        const isSomeImagesWithoutMaskWarning = selectedGroup && imagesWithMasksInSelectedGroup !== selectedGroup?.images?.length
        const isDiff = selectedGroup && selectedGroup.group_hash !== selectedGroup.published_hash
        const isError = isNoWatermarksWarning || isEmptyGroup || isSomeImagesWithoutMaskWarning || isDiff

        const templatesForWatermarkRemoval = selectedGroup && templates.isLoaded ? templates.data.filter((t: Template) => t.type === RENDERED_TYPE_AUTOWMREMOVE && t.watermark_group_id).map((t: Template) => {
            return {template_id: t.id, template_name: t.name, group_id: t.watermark_group_id}
        }) : null

        const selectedTemplate = selectedGroup && templates.isLoaded ? _find(templates.data, (template: Template) => {
            return `${template.watermark_group_id}` === `${selectedGroup.id}`
        }) : null

        const publishTemplateButton = selectedTemplate ?
            <Button
                icon={<Icon type={'send-light'} text={`publish template ${selectedTemplate.id} (group ${selectedGroup.id}) to watermark detector`} />}
                onClick={() => this.handlePublishTemplate(selectedGroup.id, selectedTemplate.id)}
            /> :
            null

        return (
            <div>
                <Message
                    type={isError ? 'error' : 'info'}
                    style={{ textAlign: 'left', borderLeft: '0', background: '#f9f9f9', marginBottom: '20px' }}
                    closeable={false}
                    icon={<Icon type={isError ? 'exclamation-triangle' : 'info-circle'} size={20} color={isError ? Theme.red : Theme.steelblue} />}
                    text={isNoWatermarksWarning ?
                        trans('no_watermark_groups_yet') :
                        (isEmptyGroup ? trans('empty_watermark_group') :
                            (isSomeImagesWithoutMaskWarning ? trans(`watermark_group_some_images_without_mask`) :
                                (isDiff ? trans('watermark_group_hash_diff') : trans(`watermark_groups_info_0`)))
                        )
                    }
                />

                <WatermarkGroupsSelect
                    selectedGroupId={selectedGroup?.id}
                    setSelectedGroup={this.setSelectedGroup}
                    variant={'tiles'}
                    maxImages={9}
                    setShowAsModal={(value) => {
                        console.debug('should toggle show as modal 2', value)
                    }}
                />

                {selectedGroup &&
                    <StyledSectionWatermarkGroups
                        color={Theme.steelblue}
                        prefix={publishTemplateButton ? publishTemplateButton : `${trans('watermark_group')} ${selectedGroup.id}`}
                        header={header}
                        suffix={<span>{selectedGroup.images?.length}</span>}
                        style={{ ' > .m-content': { padding: 0 } }}>
                        <WatermarksInEditor
                            updateWatermarkGroups={this.updateWatermarkGroups}
                            setSelectedGroupId={this.setSelectedGroup}
                            selectedGroupId={selectedGroup?.id}
                            showAsModal={showAsModal}
                            setShowAsModal={(value: boolean) => {
                                this.setState({ showAsModal: value })
                            }}
                        />
                    </StyledSectionWatermarkGroups>
                }

                {selectedGroup &&
                    <WatermarkGroupsResults watermark_group={selectedGroup} templatesForWatermarkRemoval={templatesForWatermarkRemoval} />
                }
            </div>
        )
    }
}

const StyledSectionWatermarkGroups = css(Section)({
    ' .muk-div.muk-paginator': {
        margin: '0px',
    },
    ' .m-header-content': {
        padding: '0px !important',
    },
})

function mapStateToProps(state) {
    return {
        watermarkGroups: state.watermarkGroups,
        templates: state.templates,
    }
}

export default connect(mapStateToProps, {
    setWatermarkGroupsToStore,
})(WatermarkGroupsViewTable)
